import { Injectable, signal } from '@angular/core';
import posthog from 'posthog-js';

export const FORCED_SPONSORSHIP_KILL_SWITCH_FLAG =
  'self-serve-forced-sponsorship-active';

/**
 * Client kill switch for forced-sponsorship enforcement. Edge decides whether
 * the account requires sponsorship (PlanService.getSponsorshipRequirement);
 * this flag only lets ops switch enforcement off. `killSwitchActive` stays
 * `undefined` until PostHog flags have loaded so callers can tell "not
 * loaded" from "off".
 */
@Injectable({
  providedIn: 'root',
})
export class ForcedSponsorshipService {
  private readonly _killSwitchActive = signal<boolean | undefined>(undefined);
  readonly killSwitchActive = this._killSwitchActive.asReadonly();

  constructor() {
    posthog.onFeatureFlags(() => {
      this._killSwitchActive.set(
        posthog.isFeatureEnabled(FORCED_SPONSORSHIP_KILL_SWITCH_FLAG) ?? false,
      );
    });
  }
}
